// Small helper. Throws if the element is missing — every ID we reach for is
// declared in index.html, so a miss is a programming error, not a runtime
// branch worth handling.
export function $(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing element: #${id}`);
  return el;
}
